import {useTranslation} from "react-i18next";
import {FormLayout} from "../../components/guest/layout/form/FormLayout";
import {ResetPasswordForm} from "../../components/guest/authentication/ResetPasswordForm";

export const ResetPassword = () => {
    const {t} = useTranslation("forgot");

    return (
        <FormLayout
            eyebrow={t("forgot:reset-page-eyebrow")}
            title={<>
                {t("forgot:reset-page-title-1")}<br/>
                {t("forgot:reset-page-title-2")}<br/>
                <em>{t("forgot:reset-page-title-3")}</em>
            </>}
            text={t("forgot:reset-page-text")}>
            <ResetPasswordForm/>
        </FormLayout>
    );
};